import usePageMeta from '@/hooks/usePageMeta';
import HeroBanner from './components/HeroBanner';
import EpisodeSpotlight from './components/EpisodeSpotlight';
import NewsSection from './components/NewsSection';
import DramaInfoCard from './components/DramaInfoCard';
import CollectionSidebar from './components/CollectionSidebar';

export default function Home() {
  usePageMeta({
    title: '女友的妈妈 - 电视剧全集及剧情介绍平台',
    description:
      '女友的妈妈电视剧专题网站，提供详细剧情介绍、演员资料及影视资讯，帮助观众了解和追看该剧的最新动态和精彩内容。',
    keywords: '女友的妈妈,电视剧,剧情介绍,演员表,影视资讯,剧集下载,影视平台,观看指南',
  });

  return (
    <>
      <HeroBanner />

      <div className="w-full px-4 md:px-8 py-10 md:py-12">
        <div className="max-w-[1280px] mx-auto grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-10">
          <div className="lg:col-span-2 space-y-10 md:space-y-12">
            <EpisodeSpotlight />
            <NewsSection />
          </div>
          <aside className="space-y-8 lg:space-y-10">
            <DramaInfoCard />
            <CollectionSidebar />
          </aside>
        </div>
      </div>
    </>
  );
}